import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";
import ModalContainer from "components/ModalContainer";
import { OutlineButton } from "components/buttons/OutlineButton";
import { SolidWarnButton } from "components/buttons/SolidWarnButton";

/**
 * DeleteViewModal
 * Confirmation dialog before permanently deleting a view.
 *
 * Props:
 *   open       - boolean
 *   viewName   - name of the view to delete (shown in title)
 *   onCancel   - called when Cancel is clicked
 *   onConfirm  - called when Delete is confirmed
 */
const DeleteViewModal = ({ open, viewName, onCancel, onConfirm }) => {
  const intl = useIntl();

  return (
    <ModalContainer display={open} modalWidth="500px">
      <Stack spacing={2.5} sx={{ textAlign: "center" }}>
        <Typography sx={{ fontSize: "18px", fontWeight: "bold", color: "#172664" }}>
          {intl.formatMessage({ id: "delete-view-title" }, { viewName })}
        </Typography>

        <Typography sx={{ fontSize: "14px", color: "rgba(0,0,0,0.65)", lineHeight: 1.6 }}>
          <FormattedMessage id="delete-view-body" />
        </Typography>

        <Box sx={{ borderTop: "1px solid rgba(0,0,0,0.1)" }} />

        <Stack direction="row" justifyContent="center" spacing={2}>
          <OutlineButton width="100px" height="32px" onClick={onCancel}>
            <FormattedMessage id="cancel" />
          </OutlineButton>
          <SolidWarnButton width="100px" height="32px" onClick={onConfirm}>
            <FormattedMessage id="delete" />
          </SolidWarnButton>
        </Stack>
      </Stack>
    </ModalContainer>
  );
};

export default DeleteViewModal;
